import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export default function HeroSearchFilter() {

    const [searchText, setSearchText] = useState('');
    const [propertyType, setPropertyType] = useState('');
    const [zona, setZona] = useState('');
    const [priceMin, setPriceMin] = useState('');
    const [priceMax, setPriceMax] = useState('');
    const [currency, setCurrency] = useState('USD');
    const [recamaras, setRecamaras] = useState('');
    const [banos, setBanos] = useState('');
    const [showAdvanced, setShowAdvanced] = useState(false);
    const navigate = useNavigate();

    // Datos dinámicos del MLS
    const [availableTypes, setAvailableTypes] = useState([]);
    const [availableZones, setAvailableZones] = useState([]);

    useEffect(() => {
        const loadOptions = async () => {
            try {
                const snapshot = await getDocs(query(collection(db, 'propiedades'), where('estado', '==', 'A')));
                const types = new Set();
                const zones = new Set();

                snapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.tipo_propiedad) types.add(data.tipo_propiedad);
                    if (data.zona) zones.add(data.zona);
                });

                setAvailableTypes(Array.from(types).sort());
                setAvailableZones(Array.from(zones).filter(z => z).sort());
            } catch (error) {
                console.error('Error cargando opciones de filtro:', error);
            }
        };
        loadOptions();
    }, []);

    const handleSearch = () => {
        const searchParams = new URLSearchParams();

        if (searchText.trim()) {
            searchParams.set('search', searchText.trim());
        }
        if (propertyType) {
            searchParams.set('propertyType', propertyType);
        }
        if (zona) {
            searchParams.set('zona', zona);
        }
        if (priceMin) {
            searchParams.set('priceMin', priceMin);
        }
        if (priceMax) {
            searchParams.set('priceMax', priceMax);
        }
        searchParams.set('currency', currency);
        if (recamaras) {
            searchParams.set('recamaras', recamaras);
        }
        if (banos) {
            searchParams.set('banos', banos);
        }

        navigate(`/classical-layout-with-sidebar?${searchParams.toString()}`);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const selectStyle = { backgroundColor: '#288b65', color: 'white', height: '55px', borderColor: '#288b65' };

    return (
        <div className="full-search-2 eclip-search italian-search hero-search-radius mt-5">
            <div className="hero-search-content">
                <div className="row">
                    <div className="col-xl-10 col-lg-9 col-md-9 col-sm-12 px-xl-0 px-lg-0 px-md-0">
                        <div className="form-group borders">
                            <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control border-0 ps-5 placeholder-white"
                                  placeholder="Buscar por nombre, ubicación, tipo..."
                                  value={searchText}
                                  onChange={(e) => setSearchText(e.target.value)}
                                  onKeyPress={handleKeyPress}
                                  style={{ backgroundColor: 'transparent', color: 'white' }}
                                />
                                <div className="position-absolute top-50 start-0 translate-middle-y ms-2">
                                    <i className="fa fa-search" style={{ color: '#288b65' }}></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
                        <div className="form-group">
                            <button
                              type="button"
                              className="btn full-width"
                              onClick={handleSearch}
                              style={{ backgroundColor: '#29866a', borderColor: '#29866a', color: '#ffffff' }}
                            >
                              Buscar
                            </button>
                        </div>
                    </div>
                </div>

                {/* Búsqueda Avanzada */}
                <div className="row mt-3">
                    <div className="col-12">
                        <button
                            type="button"
                            className="btn btn-link btn-sm"
                            onClick={() => setShowAdvanced(!showAdvanced)}
                            style={{ color: '#288b65' }}
                        >
                            <i className={`fa fa-chevron-${showAdvanced ? 'up' : 'down'} me-2`}></i>
                            Búsqueda Avanzada
                        </button>
                    </div>
                </div>

                {showAdvanced && (
                    <div className="row mt-3 p-3 rounded" style={{ backgroundColor: 'transparent' }}>
                        <div className="col-md-3 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Tipo</label>
                            <select
                                className="form-select"
                                value={propertyType}
                                onChange={(e) => setPropertyType(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">Todos</option>
                                {availableTypes.map(type => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Zona</label>
                            <select
                                className="form-select"
                                value={zona}
                                onChange={(e) => setZona(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">Todas</option>
                                {availableZones.map(z => (
                                    <option key={z} value={z}>{z}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Recámaras</label>
                            <select
                                className="form-select"
                                value={recamaras}
                                onChange={(e) => setRecamaras(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">Cualquiera</option>
                                <option value="1">1+</option>
                                <option value="2">2+</option>
                                <option value="3">3+</option>
                                <option value="4">4+</option>
                                <option value="5">5+</option>
                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Baños</label>
                            <select
                                className="form-select"
                                value={banos}
                                onChange={(e) => setBanos(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">Cualquiera</option>
                                <option value="1">1+</option>
                                <option value="2">2+</option>
                                <option value="3">3+</option>
                                <option value="4">4+</option>
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Moneda</label>
                            <select
                                className="form-select"
                                value={currency}
                                onChange={(e) => setCurrency(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="USD">USD</option>
                                <option value="MXN">MXN</option>
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Precio Mínimo</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="0"
                                value={priceMin}
                                onChange={(e) => setPriceMin(e.target.value)}
                                style={selectStyle}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label" style={{ color: 'white' }}>Precio Máximo</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Sin límite"
                                value={priceMax}
                                onChange={(e) => setPriceMax(e.target.value)}
                                style={selectStyle}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
